export enum InputPriceEnum {
    Merchant = 'MERCHANT',
    Mpc ='MULTI_PURPOSE_COOPERATIVE'
}